import React from 'react';

import { MenuItem, MenuList, Typography } from '@mui/material';
import clsx from 'clsx';
import { IS_SANDBOX_ENV } from 'helper/constant';
import PropTypes from 'prop-types';

import styles from './switchEnvironment.module.css';

import { ReactComponent as CheckIcon } from 'asset/IconsPack/at_check.svg';

import RequestSandboxButton from './RequestSandboxButton';
import { ENV_OPTIONS, SANDBOX_ON_REQUEST } from './constants';

function EnvironmentList({ canSwitch, onSwitch, onClose }) {
    return (
        <>
            <Typography className={styles.menuTitle}>Environment</Typography>
            <MenuList id="environment-menu" autoFocusItem className={styles.menuList}>
                {ENV_OPTIONS.map((option) => {
                    const isCurrent = option.isSandbox === IS_SANDBOX_ENV;
                    const dot = (
                        <span
                            className={clsx(styles.dot, option.isSandbox && styles.sandboxDot)}
                            aria-hidden="true"
                        />
                    );

                    if (option.isSandbox && !canSwitch) {
                        return (
                            <li
                                key={option.label}
                                className={clsx(styles.option, styles.optionMuted)}
                            >
                                {dot}
                                <span className={styles.optionText}>
                                    <span className={styles.optionLabel}>{option.label}</span>
                                    <span className={styles.optionDescription}>
                                        {SANDBOX_ON_REQUEST}
                                    </span>
                                    <RequestSandboxButton />
                                </span>
                            </li>
                        );
                    }

                    return (
                        <MenuItem
                            key={option.label}
                            className={clsx(styles.option, isCurrent && styles.optionCurrent)}
                            onClick={isCurrent ? onClose : onSwitch}
                        >
                            {dot}
                            <span className={styles.optionText}>
                                <span className={styles.optionLabel}>{option.label}</span>
                                <span className={styles.optionDescription}>
                                    {option.description}
                                </span>
                            </span>
                            {isCurrent && <CheckIcon className={styles.check} aria-hidden="true" />}
                        </MenuItem>
                    );
                })}
            </MenuList>
        </>
    );
}

EnvironmentList.propTypes = {
    canSwitch: PropTypes.bool,
    onSwitch: PropTypes.func,
    onClose: PropTypes.func,
};

export default EnvironmentList;
